import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Share2 } from 'lucide-react';
import { MetaTags } from '../../../../components/SEO/MetaTags';
import { RelatedBlogPosts } from '../../../../components/Blog/RelatedBlogPosts';
export function BlogPostEmotionalDrainPart2ES() {
  const articleData = {
    title: '¿Por qué algunas personas nos hacen sentir agotados? Parte 2',
    description: 'Más patrones sutiles que agotan tu energía. La IA detecta sobre-explicación, sabelotodos, confusión de emojis y más.',
    slug: 'emotional-drain-part-2',
    publishDate: '2025-11-16',
    author: 'Toxic Detector Editorial'
  };
  const articleSchema = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: articleData.title,
    description: articleData.description,
    datePublished: articleData.publishDate,
    author: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    },
    publisher: {
      '@type': 'Organization',
      name: 'ToxicDetector'
    }
  };
  const handleShare = async () => {
    try {
      await navigator.share({
        title: articleData.title,
        text: articleData.description,
        url: 'https://toxicdetector.com/'
      });
    } catch (err) {
      navigator.clipboard.writeText(window.location.href);
      alert('¡Enlace copiado al portapapeles!');
    }
  };
  return <>
      <MetaTags title="¿Por qué algunas personas nos hacen sentir agotados? Parte 2 | ToxicDetector" description="Más patrones sutiles que agotan tu energía. La IA detecta sobre-explicación, sabelotodos, confusión de emojis y más." keywords="agotamiento emocional, vampiros de energía, relaciones tóxicas, análisis IA" canonical={`https://toxicdetector.com/es/blog/${articleData.slug}`} ogType="article" ogImage="https://toxicdetector.com/images/logo.png" schema={[articleSchema]} data-id="element-4908" data-mp="ikmj6nkorkb4" />

      <div className="flex flex-col w-full min-h-screen bg-white" data-id="element-4909" data-mp="33a26h8kp4qw0">
        <header className="bg-white/95 backdrop-blur-md border-b border-gray-100 sticky top-0 z-50" data-id="element-4910" data-mp="ae910ddqw8fa">
          <div className="max-w-4xl mx-auto px-6 py-5" data-id="element-4911" data-mp="5fpfge32cyng">
            <div className="flex items-center justify-between" data-id="element-4912" data-mp="5ha81y5ti7io">
              <Link to="/" className="flex items-center gap-2 group" data-id="element-4913" data-mp="jg9y9a8zaugy">
                <span className="text-2xl" data-id="element-4914" data-mp="egdu9b0a731e">🚩</span>
                <span className="text-xl font-bold text-gray-900 group-hover:text-red-600 transition-colors" data-id="element-4915" data-mp="eeknlvpo4ite">
                  ToxicDetector
                </span>
              </Link>
              <button onClick={handleShare} className="p-2.5 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-4916" data-mp="odihzf9rz6kb">
                <Share2 size={20} className="text-gray-600" data-id="element-4917" data-mp="y4d5emyrcc7c" />
              </button>
            </div>
          </div>
        </header>

        <article className="max-w-4xl mx-auto w-full px-6 py-16" data-id="element-4918" data-mp="1c4xnfgwum3zs">
          <Link to="/" className="inline-flex items-center text-gray-600 text-sm mb-12 hover:text-gray-900 transition-colors group" data-id="element-4919" data-mp="1751jfho5ick8">
            <ArrowLeft size={16} className="mr-2 group-hover:-translate-x-1 transition-transform" data-id="element-4920" data-mp="1qoiajy3hef4f" />
            Volver al Inicio
          </Link>

          <header className="mb-16" data-id="element-4921" data-mp="1gs5it5rhybcb">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 tracking-tight leading-[1.1] text-gray-900" data-id="element-4922" data-mp="1lri77uy0nqh0">
              {articleData.title}
            </h1>
            <div className="flex items-center text-gray-500 text-sm gap-3" data-id="element-4923" data-mp="17yinfgr7ba3n">
              <time dateTime={articleData.publishDate} data-id="element-4924" data-mp="1crvb9oo23cvc">
                {new Date(articleData.publishDate).toLocaleDateString('es-MX', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
              </time>
              <span className="text-gray-300" data-id="element-4925" data-mp="p0ppksvfpqd4">•</span>
              <span data-id="element-4926" data-mp="p3c5bfshbc6f">{articleData.author}</span>
            </div>
          </header>

          <div className="prose prose-lg max-w-none" data-id="element-4927" data-mp="t2b92x2h52wa">
            <p className="text-2xl mb-10 leading-relaxed text-gray-700 font-medium" data-id="element-4928" data-mp="m060k9glh342">
              Bienvenidos de nuevo a la Parte 2 de nuestra serie sobre
              agotamiento emocional. En la Parte 1, cubrimos los vampiros de
              energía obvios. Ahora profundizamos en los patrones más sutiles.
            </p>

            <section className="mb-16" data-id="element-4929" data-mp="79yqah0qqqeg">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4930" data-mp="78vzsa7bypz2">
                1️⃣ El Sobre-Explicador
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4931" data-mp="3uf6fe1qtqf9u">
                Alguien que responde preguntas simples con novelas y ata tu
                energía con detalles innecesarios.
              </p>
            </section>

            <section className="mb-16" data-id="element-4932" data-mp="3kj33w5a314a8">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4933" data-mp="1noq8k146aha1">
                2️⃣ El Sabelotodo
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4934" data-mp="1ir6tx03kc2hk">
                No importa lo que digas, esta persona lo sabe mejor o lo ha
                tenido peor. Un comportamiento clásico de "One-Upper".
              </p>
            </section>

            <section className="mb-16" data-id="element-4935" data-mp="1zzhjokmj0kl4">
              <h2 className="text-4xl font-bold mb-8 tracking-tight text-gray-900" data-id="element-4936" data-mp="200iwatj6xf4y">
                3️⃣ Confusión de Emojis
              </h2>
              <p className="text-lg leading-relaxed text-gray-600" data-id="element-4937" data-mp="25058r0r72rcp">
                Usar emojis pasivo-agresivos como 🙂 o 🙃 en contextos serios
                para crear confusión.
              </p>
            </section>
          </div>

          <div className="bg-red-600 rounded-2xl p-12 md:p-16 text-center text-white shadow-xl mt-16" data-id="element-4938" data-mp="1h8gkpwleop1k">
            <h2 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight leading-tight" data-id="element-4939" data-mp="1m8uk6q8xyqnz">
              Protege tu energía.
            </h2>
            <p className="text-red-100 mb-10 text-xl leading-relaxed max-w-2xl mx-auto" data-id="element-4940" data-mp="2spznxoyzks04">
              No dejes que te agoten. Descubre quién es bueno para ti.
            </p>
            <Link to="/upload" className="inline-block bg-white text-red-600 px-12 py-5 rounded-xl font-bold text-lg hover:bg-gray-50 transition-all shadow-lg hover:shadow-xl hover:scale-105" data-id="element-4941" data-mp="27x9hz77tolcy">
              Escanear ahora →
            </Link>
          </div>

          <div className="mt-20" data-id="element-4942" data-mp="2cygo71ubhchi">
            <RelatedBlogPosts posts={[{
            title: '¿Por qué algunas personas nos hacen sentir agotados?',
            description: 'Aprende cómo la IA de Toxic Detector detecta la comunicación unilateral.',
            slug: 'emotional-drain-relationships-ai',
            emoji: '😮‍💨'
          }, {
            title: '7 Señales de Gaslighting',
            description: 'Descubre 7 señales de gaslighting que nuestra IA detecta al instante.',
            slug: '7-signs-of-gaslighting',
            emoji: '💀'
          }]} data-id="element-4943" data-mp="1p8cmj00ovmt5" />
          </div>
        </article>

        <footer className="bg-gray-900 text-white py-16 mt-24" data-id="element-4944" data-mp="3hxlxq27o8e4o">
          <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-4945" data-mp="338g2epbyf822">
            <p className="text-gray-400 text-sm" data-id="element-4946" data-mp="335uyzvw0ck27">
              © {new Date().getFullYear()} ToxicDetector. Todos los derechos
              reservados.
            </p>
          </div>
        </footer>
      </div>
    </>;
}